(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('RejectedRowDeleteController',RejectedRowDeleteController);

    RejectedRowDeleteController.$inject = ['$uibModalInstance', 'entity', 'RejectedRow'];

    function RejectedRowDeleteController($uibModalInstance, entity, RejectedRow) {
        var vm = this;

        vm.rejectedRow = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
        	RejectedRow.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
